export const Events = {
  CLICK: 'recipe-card:click'
}
